import { FC, SyntheticEvent } from 'react';
import { IconButton } from '@/lib';
import { DataSource } from '@/models/dataSource';

import EyeIcon from '@/assets/icons/eye.svg?react';
import EditIcon from '@/assets/icons/edit.svg?react';
import { DataSourceDeleteButton } from '../../../commons';
import { useHistory } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';

type DataSourceRapidActionsColumnProps = {
  datasource: DataSource;
};

export const DataSourceRapidActionsColumn: FC<DataSourceRapidActionsColumnProps> = ({ datasource }) => {
  const history = useHistory();
  const isWorkspaceAdmin = useWorkspaceAdmin();

  const handleEditButtonClick = (event: SyntheticEvent<HTMLButtonElement, Event>) => {
    event.stopPropagation();

    history.push(`${RouteConstants.dataSources}/${datasource.id}`);
  };

  const Icon = () => (isWorkspaceAdmin ? <EditIcon /> : <EyeIcon />);

  return (
    <div className='flex items-center gap-1.5'>
      <IconButton intent='link-grey' className='!p-1.5 text-quaternary-400' leadingIcon={<Icon />} onClick={handleEditButtonClick} />
      {isWorkspaceAdmin && <DataSourceDeleteButton datasource={datasource} />}
    </div>
  );
};
